import {
  DEFAULT_CONTENT_DURATION,
  VALID_MIMETYPES,
} from "fleet/constant/media-library";
import { isValidMimeType } from "fleet/view/media-library/utils";
import PropTypes from "prop-types";
import React from "react";
import { Button, FormControl } from "react-bootstrap";

class MediaUploadButton extends React.Component {
  static get displayName() {
    return "MediaUploadButton";
  }

  static get propTypes() {
    return {
      onError: PropTypes.func.isRequired,
      uploadMedia: PropTypes.func.isRequired,
      folderId: PropTypes.number,
    };
  }

  constructor(props) {
    super(props);

    this._triggerChange = this._triggerChange.bind(this);
    this._onChange = this._onChange.bind(this);
    this._setInputRef = this._setInputRef.bind(this);
  }

  _setInputRef(r) {
    this.input = r;
  }

  _triggerChange() {
    this.input.click();
  }

  _onChange(e) {
    const file = e.target.files[0];
    const { folderId, onError, uploadMedia } = this.props;

    if (!isValidMimeType(file.type)) {
      onError(`File mime type should be one of ${VALID_MIMETYPES.join(", ")}`);
      return;
    }

    uploadMedia({
      duration: DEFAULT_CONTENT_DURATION,
      name: file.name,
      filename: file.name,
      file,
      folderId,
    });
  }

  render() {
    return (
      <span>
        <FormControl
          type="file"
          style={{ display: "none" }}
          ref={this._setInputRef}
          onChange={this._onChange}
        />
        <Button onClick={this._triggerChange} variant="primary">
          Upload Media
        </Button>
      </span>
    );
  }
}

export { MediaUploadButton };
